export default __webpack_public_path__ + "static/media/May_9th_2023.fdb9acf8.jpeg";